(function () {
  "use strict";

  const SELECTORS = {
    mainCarousel: ".js-splide-top-main",
    productCarousel: ".js-splide_products",
    rankingSection: ".v2-products-ranking",
    categoriesAll: ".v2-categories-all",
  };

  // 自動再生: OS のモーション低減設定時は無効化（カテゴリページ v2-splide-snippets.js と同仕様）
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const SPLIDE_CONFIG = {
    main: {
      autoplay: !prefersReducedMotion,
      type: "loop",
      pagination: true,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 5000,
      speed: 300,
      perPage: 1,
      fixedWidth: "var(--top-w, 1080px)",
      padding: "calc((100% - var(--top-w, 1080px)) / 2)",
      lazyLoad: "nearby",
      preloadPages: 1,
      flickPower: 300,
      gap: 10,
      breakpoints: {
        1080: {
          fixedWidth: "calc((350 / 390) * 100vw)",
          padding: "calc((20 / 390) * 100vw)",
          gap: 8,
          arrows: false,
        },
      },
    },
    product: {
      autoplay: false,
      type: "slide",
      pagination: false,
      arrows: true,
      interval: 1000,
      speed: 300,
      fixedWidth: 255,
      perPage: 1,
      drag: true,
      start: 0,
      breakpoints: {
        1080: {
          autoWidth: true,
          gap: 0,
          arrows: false,
        },
      },
    },
  };

  const initMainCarousel = () => {
    const mainCarousel = document.querySelector(SELECTORS.mainCarousel);
    if (!mainCarousel) return;

    /* 共通スライダー v2-rail.js があればそれで動かす（Splide を読み込まない。9/29 脱ライブラリ） */
    if (window.V2Rail) {
      // 2 枚目と最後（ループで左に見える 1 枚）は、1 枚目（LCP）が読み終わってから取りに行く（帯域を取り合わない）
      const imgs = mainCarousel.querySelectorAll(".splide__slide:not([data-v2-rail-clone]) img");
      let railApi = null;
      /* URL を戻す（source の srcset を先に戻してから img の src） */
      const restore = function (root) {
        root.querySelectorAll("img").forEach(function (img) { if (img !== imgs[0]) { img.loading = "eager"; img.fetchPriority = "low"; } });
        root.querySelectorAll("source[data-v2-srcset], img[data-v2-srcset]").forEach(function (el) { el.setAttribute("srcset", el.getAttribute("data-v2-srcset")); el.removeAttribute("data-v2-srcset"); });
        root.querySelectorAll("img[data-v2-src]").forEach(function (el) { el.setAttribute("src", el.getAttribute("data-v2-src")); el.removeAttribute("data-v2-src"); });
      };
      /* 10/10 速度: 1 枚目の後にすぐ取るのは隣（2 枚目）と最後（ループで左に見える 1 枚）だけ。
         3 枚目以降はページの読み込み完了・カルーセルに触れた・4 秒経過のどれか早い方で取る（自動送りは 5 秒なので間に合う） */
      const own = Array.prototype.slice.call(mainCarousel.querySelectorAll(".splide__slide:not([data-v2-rail-clone])"));
      const warmNeighbors = function () {
        [own[1], own[own.length - 1]].forEach(function (sl) { if (sl) restore(sl); });
        if (railApi && railApi.warm) railApi.warm();
      };
      let restDone = false;
      const warmRest = function () {
        if (restDone) return;
        restDone = true;
        warmNeighbors();
        restore(mainCarousel);
      };
      if (imgs[0] && !imgs[0].complete) imgs[0].addEventListener("load", warmNeighbors, { once: true });
      else window.setTimeout(warmNeighbors, 0);
      if (document.readyState === "complete") window.setTimeout(warmRest, 0);
      else window.addEventListener("load", warmRest, { once: true });
      window.setTimeout(warmRest, 4000);
      ["pointerdown", "touchstart", "focusin", "mouseenter"].forEach(function (ev) { mainCarousel.addEventListener(ev, warmRest, { once: true, passive: true }); });
      const rail = railApi = window.V2Rail.create(mainCarousel, {
        mode: "slides",
        loop: true,
        dots: true,
        nav: true,
        autoplay: prefersReducedMotion ? 0 : 5000,
        toggle: mainCarousel.querySelector(".mv-autoplay-toggle"),
        slides: ":scope > .splide__slide",
      });
      document.addEventListener("v2top:widthchange", function () { rail.update(); });
      return;
    }

    const splide = new Splide(mainCarousel, SPLIDE_CONFIG.main);
    mainCarousel.splide = splide;
    document.addEventListener("v2top:widthchange", function () {
      splide.refresh();
    });

    // アクティブドットを進捗バー化 + 一時停止トグルをドット列末尾へ
    //（カテゴリページ v2-splide-snippets.js と同実装。Splideネイティブの
    //  splide__toggle は refresh() で束縛が外れるため Autoplay を直接制御する）
    splide.on("autoplay:playing", function (rate) {
      mainCarousel.style.setProperty("--mv-progress", rate);
    });
    const mvToggle = mainCarousel.querySelector(".mv-autoplay-toggle");
    const mvAutoplay = function () {
      return splide.Components.Autoplay;
    };
    const updateToggle = function () {
      if (!mvToggle) return;
      const paused = mvAutoplay().isPaused();
      mvToggle.classList.toggle("is-paused", paused);
      mvToggle.setAttribute(
        "aria-label",
        paused ? "スライドの自動再生を再開" : "スライドの自動再生を一時停止"
      );
    };
    const appendToggleToPagination = function () {
      const pagination = mainCarousel.querySelector(".splide__pagination");
      if (!mvToggle || !pagination) return;
      const li = document.createElement("li");
      li.className = "mv-autoplay-toggle-item";
      li.setAttribute("role", "presentation");
      li.appendChild(mvToggle);
      pagination.appendChild(li);
    };
    if (mvToggle) {
      mvToggle.addEventListener("click", function () {
        if (mvAutoplay().isPaused()) {
          mvAutoplay().play();
        } else {
          mvAutoplay().pause();
        }
        updateToggle();
      });
    }
    splide.on("pagination:mounted", appendToggleToPagination);
    splide.on("autoplay:play", updateToggle);
    splide.on("autoplay:pause", updateToggle);
    splide.on("move", function () {
      if (mvAutoplay().isPaused()) {
        mainCarousel.style.setProperty("--mv-progress", 0);
      }
    });

    splide.mount();
    appendToggleToPagination();
    updateToggle();

    // Loop modeの初期位置ずれを修正（操作すると直る問題の対策）
    if (window.innerWidth >= 1080) {
      var fixPosition = function () {
        splide.refresh();
      };
      requestAnimationFrame(function () {
        requestAnimationFrame(fixPosition);
      });
      // 画像の遅延読み込み後にも再計算
      setTimeout(fixPosition, 150);
    }
  };

  const initProductCarousels = () => {
    /* トップの製品レールは v2-top-scene-finder のスクリプトが v2-rail.js で動かす */
    if (window.V2Rail) return;
    const carousels = document.querySelectorAll(SELECTORS.productCarousel);
    if (carousels.length === 0 || typeof Splide === "undefined") return;

    var rootMarginPx = 200;

    function isInViewport(el) {
      var rect = el.getBoundingClientRect();
      var margin = rootMarginPx;
      return rect.top < window.innerHeight + margin && rect.bottom > -margin;
    }

    function mountCarousel(el) {
      if (!el || el.classList.contains("is-initialized") || el.classList.contains("is-native")) return;
      var scrollY = window.scrollY;
      el.splide = new Splide(el, SPLIDE_CONFIG.product).mount();
      if (Math.abs(window.scrollY - scrollY) > 1) {
        window.scrollTo(0, scrollY);
      }
    }
    window.__v2ProductRails = { mount: mountCarousel };

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            mountCarousel(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: rootMarginPx + "px" },
    );

    carousels.forEach(function (el) {
      if (isInViewport(el)) {
        mountCarousel(el);
      } else {
        observer.observe(el);
      }
    });
  };

  const initRankingToggle = () => {
    // ここで付け終えるまでのクリックは theme.liquid の先行スクリプトが切り替えている。以後はこちらに任せる
    window.__v2RankReady = true;
    // 同一ページに .v2-products-ranking が複数（例: 「プライムデー注目製品」と
    // 「売れ筋ランキング」）存在するため、ボタン/アイテムはセクション単位でスコープする。
    // グローバルに querySelectorAll すると一方のタブ操作で他方の is-current が
    // 全解除され、もう片方の製品群が消える不具合になる。
    const rankingSections = document.querySelectorAll(SELECTORS.rankingSection);

    if (rankingSections.length === 0) return;

    const loadImagesInTab = (tabElement) => {
      if (!tabElement) return;
      const imgs = tabElement.querySelectorAll(
        ".product-card-default-thum-image",
      );
      imgs.forEach((img) => {
        if (!img.complete && img.src) {
          new Image().src = img.src;
          if (img.decode) {
            img.decode().catch(() => {});
          }
        }
      });
    };

    rankingSections.forEach((section) => {
      const buttons = section.querySelectorAll(".button");
      const items = section.querySelectorAll(".items");

      if (buttons.length === 0 || items.length === 0) return;

      /* 中身が <template> に入っているタブは、押した（乗った）ときに組み立てる */
      const materialize = (el) => {
        const t = el && el.querySelector(":scope > template[data-rank-tpl]");
        if (t) { el.appendChild(t.content); t.remove(); }
      };
      buttons.forEach((button, index) => {
        const warm = () => materialize(items[index]);
        button.addEventListener("pointerenter", warm, { passive: true });
        button.addEventListener("touchstart", warm, { passive: true });
        button.addEventListener("focus", warm);
        button.addEventListener("click", () => {
          materialize(items[index]);
          buttons.forEach((btn) => btn.classList.remove("is-current"));
          items.forEach((item) => item.classList.remove("is-current"));

          button.classList.add("is-current");
          const activeTab = items[index];
          if (activeTab) {
            activeTab.classList.add("is-current");
            requestAnimationFrame(() => {
              if (window.themeV2?.resetProductCardImages) {
                window.themeV2.resetProductCardImages();
              }
              loadImagesInTab(activeTab);
              if (window.themeV2?.setSwipeProductCardImage) {
                window.themeV2.setSwipeProductCardImage();
              }
            });
          }
        });
      });
    });
  };

  const initCategoriesAll = () => {
    const categoryExpand =
      window.themeV2?.categoryExpand || window.categoryExpand;
    if (typeof categoryExpand !== "function") return;

    categoryExpand(SELECTORS.categoriesAll);

    window.addEventListener(
      "resize",
      () => categoryExpand(SELECTORS.categoriesAll),
      { passive: true },
    );
  };

  const initialize = () => {
    initMainCarousel();
    initProductCarousels();
    initRankingToggle();
    initCategoriesAll();
  };

  document.addEventListener("DOMContentLoaded", initialize);
})();
